import XEClipboard from 'xe-clipboard';
import {
  countSingleColumn,
  isEditable,
  appendRow,
  activeNextCell,
  activeFirstCell
} from '../util/componentUtil';
import * as appUtils from '../util/appUtils';
import { ARROW_DOWN, ARROW_UP, compareKeyCode, ENTER, TAB } from '../util/keyCode';
/*import {
  FIELD_DATA_TYPE_ALL_DATE_TIME_OPTIONS,
  FIELD_INPUT_TYPE_ALL_DATE_TIME_OPTIONS
} from '@/util/meta-query-constant';*/
import {
  CLEAR_FIXED_COLUMN,
  COPY_CODE,
  FIXED_LEFT_COLUMN,
  FIXED_RIGHT_COLUMN,
  PASTE_CODE,
  TABLE_SETTING_STYLE
} from '@/util/table-setting-constant';
// export const COPY_CODE = 'menu_copy_cell';

// ------------------------------------methods 部分函数-------------------------------
/**
 * 鼠标左键点击事件处理，让选中的单元格再次点击进入编辑状态
 * @param $event
 * @param $grid
 * @param $table
 */
export function handleMouseDownCapture({ $event, $grid, $table }) {
  if (this.mouseDownCaptureActiveCellFlag) {
    return;
  }
  const xTable = $grid || $table;
  // 不是鼠标左键直接返回
  if ($event.button !== 0) {
    return;
  }
  if (
    this.lastMouseDownCaptureTimestamp &&
    $event.timeStamp - this.lastMouseDownCaptureTimestamp < 250
  ) {
    this.lastMouseDownCaptureTimestamp = $event.timeStamp;
    return;
  }
  this.lastMouseDownCaptureTimestamp = $event.timeStamp;
  let target = $event.target;
  let tableCellElement = null;
  // 向上查找tr元素
  while (true) {
    if (!target) {
      return;
    }
    if (target instanceof HTMLTableCellElement) {
      tableCellElement = target;
    }
    if (target instanceof HTMLTableRowElement) {
      // 没有点击到单元格，直接退出
      if (!tableCellElement) {
        return;
      }
      // 根据tr元素获取对应row
      const rowNode = xTable.getRowNode(target);
      if (!rowNode || !rowNode.item) {
        return;
      }
      const row = rowNode.item;
      // 获取用户选中的row
      const cellAreas = xTable.getCellAreas();
      // 没有选中，或者通过ctrl + 点击的方式选中多个单元格直接返回
      if (!Array.isArray(cellAreas) || cellAreas.length !== 1) {
        return;
      }
      const rows = cellAreas[0].rows;
      const cols = cellAreas[0].cols;
      // 选中了多行或者没有一行也没有选中，就不做处理
      // 这里同事也把当前单元格或其它单元格处于激活状态这种情况排除掉
      if (!Array.isArray(rows) || rows.length !== 1) {
        return;
      }
      if (!Array.isArray(cols) || cols.length !== 1) {
        return;
      }
      // 点击的行和选中的行不一致
      if (row !== rows[0]) {
        return;
      }
      // 激活单元格
      const columnNode = xTable.getColumnNode(tableCellElement);
      if (!columnNode || !columnNode.item) {
        return;
      }
      // 点击的列和选中列不一致
      const column = columnNode.item;
      if (column !== cols[0]) {
        return;
      }
      this.mouseDownCaptureActiveCellFlag = true;
      setTimeout(() => {
        // 如果是在dialog里面，如meta-query-dialog, 用户快速点击，就会触发双击，直接返回数据
        // 放到setTimeout内部执行，就是为了等双击的处理函数都执行完毕，ui更新完毕再去执行这些逻辑
        // 此时会关闭dialog,导致setActiveCell内部的this.$refs.xTable是空，setActiveCell返回undefined,因此需要先判断返回结果
        const promise = xTable.setActiveCell(row, column);
        if (promise) {
          promise.finally(() => {
            this.mouseDownCaptureActiveCellFlag = false;
          });
        } else {
          this.mouseDownCaptureActiveCellFlag = false;
        }
      }, 100);
      return;
    }
    target = target.parentElement;
  }
}

/**
 * 监听document的在capture过程的keydown事件
 * @param $event
 * @param $grid
 * @param $table
 */
export async function handleKeyDownCapture({ $event, $grid, $table }) {
  const tableInstance = $grid || $table;
  // 如果页面是非当前页，且注册了监听事件，此时通过this.$refs方式是无法获取到组件的
  if (!tableInstance) {
    return;
  }
  const key = $event.key;
  if (compareKeyCode(key, ARROW_DOWN) || compareKeyCode(key, ARROW_UP)) {
    // 获取激活行，如果有激活单元格
    // 当前行不是最后一行，就跳到下一行，且将同列单元格设置选中状态
    // 当前行是最后一行，就将当前单元取消激活，改为选中
    const lastRow = this.getLastRow({ $grid, $table });
    const activeRecord = tableInstance.getActiveRecord();
    if (activeRecord) {
      let row = activeRecord.row;
      const column = activeRecord.column;
      // const params = column.params;
      // 部分单元格编辑状态下的组件需要处理keydown或者keyup事件,destroyPopper需要设置为true,入el-date-picker
      // if (params && params.keyEventListener === true) {
      //   return;
      // }
      // 先改为根据path来判断是不是日期控件
      if (!$event.path) return false;
      for (const item of $event.path) {
        // body, html, document，可能没有classList
        if (!item.classList) {
          break;
        }
        for (const classItem of item.classList) {
          if (classItem === 'el-date-editor') {
            return;
          }
        }
      }
      tableInstance.clearActived().then(() => {
        // 这里有一个问题，如果isArrow是true,就是直接将当前单元格设置为选中，然后vxe-table自行选中下一个单元格
        // 如果isArrow是false,就是通过setCellAreas来选中一下个单元格，此时滚动条会自动滚动
        if (tableInstance.keyboardConfig.isArrow !== true) {
          const fullData = tableInstance.getTableData().fullData;
          if (row !== lastRow && compareKeyCode(key, ARROW_DOWN)) {
            row = fullData[fullData.indexOf(row) + 1];
          }
          if (row !== fullData[0] && key === ARROW_UP) {
            row = fullData[fullData.indexOf(row) - 1];
          }
        }
        tableInstance.setCellAreas([
          { startRow: row, endRow: row, startColumn: column, endColumn: column }
        ]);
      });
      return;
    }
  }
  if (compareKeyCode(key, ARROW_DOWN)) {
    if (!(await this.isAddNewRowEnabled())) {
      return;
    }
    if (this.keyDownCaptureAddNewRowFlag) {
      return;
    }
    const lastRow = this.getLastRow({ $grid, $table });
    // 没有最后一行，直接退出，与新方法保持一致
    if (!lastRow) {
      return;
    }
    // 判断是不是最后一行处于选中状态
    const cellAreas = tableInstance.getCellAreas();
    // 没有选中，或者通过ctrl + 点击的方式选中多个单元格直接返回
    if (!Array.isArray(cellAreas) || cellAreas.length !== 1) {
      return;
    }
    const rows = cellAreas[0].rows;
    // 选中了多行或者没有一行也没有选中，就不做处理
    if (!Array.isArray(rows) || rows.length !== 1) {
      return;
    }
    // 选中行不是最后一行
    if (lastRow !== rows[0]) {
      return;
    }
    this.coreAddNewRow && this.coreAddNewRow({ $grid, $table });
  }
}

/**
 * 激活单元切换前的回调方法
 * @param row
 * @param column
 * @param activeArea
 * @param isDown
 * @param $event
 */
export function handleActiveCellChangeStart(args) {
  // console.log('start');
  // console.log(args);
  // console.log(args.$event.timeStamp);
  // if (!this.activeCellChangeStartTimeStamp) {
  //   this.activeCellChangeStartTimeStamp = args.$event.timeStamp;
  // }
  // console.log(args.$event.timeStamp - this.activeCellChangeStartTimeStamp);
  // console.log(this.activeCellChangeStartTimeStamp);
  // console.log(args.$event.timeStamp - this.lastMouseDownTimestamp);
  // this.activeCellChangeStartTimeStamp = args.$event.timeStamp;
  // 记录activeCellChange的触发标记，keydown事件的处理函数中会用到
  this.activeCellChangeFlag = true;
}
/**
 * 激活单元格切换后的回调方法
 * @param args
 */
export function handleActiveCellChangeEnd(args) {
  const { $event, beforeActiveArea, activeArea, $grid, $table } = args;
  const tableInstance = $grid || $table;
  this.activeCellChangeFlag = false;
  if ($event.type.toLowerCase() !== 'mousedown') {
    return;
  }
  // 不是鼠标左键直接返回
  if ($event.button !== 0) {
    return;
  }
  if (tableInstance.$delayActiveCellFunction) {
    return;
  }
  if (!beforeActiveArea || !activeArea) {
    return;
  }
  // 判断activeArea和beforeActiveArea是不是同一个单元，如果是，就设置为激活，即编辑状态
  if (beforeActiveArea.column !== activeArea.column || beforeActiveArea.row !== activeArea.row) {
    return;
  }
  // 如果配置editConfig.trigger不是'manual'模式，就不需要处理
  if (tableInstance.editConfig && tableInstance.editConfig.trigger !== 'manual') {
    return;
  }
  // 这里创建一个延时执行函数,这个延时执行函数是为了判断用户是否有双击，如果用户双击，这个延时执行函数就会在
  // 双击的回调函数中清空掉
  const $timeStamp = $event.timeStamp;
  tableInstance.$delayActiveCellFunction = timeStamp => {
    // 通过timeStamp判断延时函数是否有重新初始化
    // 有一种场景是快速点击，setTimeout本来是执行上一次初始化大$delayActiveCellFunction，但是这个方法在dblclick中
    // 变成null,但是未到setTimeout的执行，此时又执行handleActiveCellChangeEnd，$delayActiveCellFunction又重新初始化
    if (timeStamp !== $timeStamp) {
      return;
    }
    const promise = tableInstance.setActiveCell(activeArea.row, activeArea.column);
    if (promise) {
      promise.finally(() => {
        tableInstance.$delayActiveCellFunction = null;
      });
    } else {
      tableInstance.$delayActiveCellFunction = null;
    }
  };
  if (tableInstance.$delayActiveCellTimeoutId) {
    clearTimeout(tableInstance.$delayActiveCellTimeoutId);
  }
  tableInstance.$delayActiveCellTimeoutId = setTimeout(
    timeStamp => {
      // 如果用户没有双击，就会在300毫秒后执行该延时执行函数
      // 经测试，第一次点击和第二次点击相差400毫秒仍然触发dblclick
      // 但是为了兼顾用户体验，使界面可以快速响应，设置300毫秒延时
      // 如果要提高准确率，就加大延时时间
      if (tableInstance.$delayActiveCellFunction) {
        tableInstance.$delayActiveCellFunction(timeStamp);
      }
    },
    180,
    $timeStamp
  );
}

/**
 * 双击的回调函数
 * @param args
 */
export function handleCellDblclick(args) {
  console.log('handleCellDblclick', args);
  const { $grid, $table } = args;
  const tableInstance = $grid || $table;
  tableInstance.$delayActiveCellFunction = null;
  if (tableInstance.$delayActiveCellTimeoutId) {
    clearTimeout(tableInstance.$delayActiveCellTimeoutId);
  }
}
/**
 * keydown事件处理函数, handleKeyDown与handleKeydown只是相差了一个字母的大小写，handleKeyDown是配合handleKeyDownCapture使用的
 * handleKeydown是配合handleActiveCellChangeStart和handleActiveCellChangeEnd使用的（这两个插件是vxe-table-pro提供的）
 * @param $event
 * @param $grid
 * @param $table
 */
export function handleKeyDown({ $event, $grid, $table }) {
  const key = $event.key;
  if (compareKeyCode(key, ENTER)) {
    activeNextCell({ $grid, $table }).then(() => {
      this.handleActiveNextCell && this.handleActiveNextCell();
    });
  }
  if (
    compareKeyCode(key, ARROW_DOWN) ||
    compareKeyCode(key, ARROW_UP) ||
    compareKeyCode(key, TAB)
  ) {
    const tableInstance = $grid || $table;
    // 在单元激活状态下，点击上下键会使上一个或下一个单元格处于选中状态，此时$el会失去焦点导致无法监听keydown-capture
    // 在单元激活状态下，点击上下键会使上一个或下一个单元格处于选中状态，此时$el会使用焦点导致无法监听keydown-capture
    tableInstance.focus().then(() => {
      tableInstance.$el.focus();
    });
  }
}
/**
 * keydown事件处理函数，handleKeyDown与handleKeydown只是相差了一个字母的大小写，handleKeyDown是配合handleKeyDownCapture使用的
 * handleKeydown是配合handleActiveCellChangeStart和handleActiveCellChangeEnd使用的（这两个插件是vxe-table-pro提供的）
 * @param $event
 * @param $grid
 * @param $table
 */
export function handleKeydown({ $event, $grid, $table }) {
  const key = $event.key;
  if (compareKeyCode(key, ENTER)) {
    activeNextCell({ $grid, $table }).then(() => {
      this.handleActiveNextCell && this.handleActiveNextCell();
    });
  }
  // 如果是上下键，需要分一下几种情况来控制
  // 单元格处于激活装状态，就转成非激活，且选中上一行或下一行对应的单元格
  // 单元格处于选中状态，如果keyboardConfig.isArrow是true, 此时this.activeCellChangeFlag为true,如果isArrow是false,activeCellChangeFlag为false
  // 第一行向上，或者最后一行向下，this.activeCellChangeFlag为false，因此this.activeCellChangeFlag为true不需要处理
  // 最后一样向下需要判断是否需要新增一行
  if (compareKeyCode(key, ARROW_DOWN) || compareKeyCode(key, ARROW_UP)) {
    if (this.activeCellChangeFlag) {
      return;
    }
    const tableInstance = $grid || $table;
    const lastRow = getLastRow({ $grid, $table });
    const activeRecord = tableInstance.getActiveRecord();
    if (activeRecord) {
      let row = activeRecord.row;
      const column = activeRecord.column;
      tableInstance.clearActived().then(() => {
        const fullData = tableInstance.getTableData().fullData;
        if (row !== lastRow && compareKeyCode(key, ARROW_DOWN)) {
          row = fullData[fullData.indexOf(row) + 1];
        }
        if (row !== fullData[0] && key === ARROW_UP) {
          row = fullData[fullData.indexOf(row) - 1];
        }
        tableInstance.setCellAreas([
          { startRow: row, endRow: row, startColumn: column, endColumn: column }
        ]);
      });
      return;
    }
    // 判断是不是最后一行处于选中状态
    const cellAreas = tableInstance.getCellAreas();
    // 没有选中，或者通过ctrl + 点击的方式选中多个单元格直接返回
    if (!Array.isArray(cellAreas) || cellAreas.length !== 1) {
      return;
    }
    const rows = cellAreas[0].rows;
    // 选中了多行或者没有一行也没有选中，就不做处理
    if (!Array.isArray(rows) || rows.length !== 1) {
      return;
    }
    // 选中行不是最后一行
    if (lastRow !== rows[0]) {
      return;
    }
    if (this.coreAddNewRow) {
      this.coreAddNewRow({ $grid, $table });
    }
  }
}

/**
 * 获取最后一行
 * @param $grid
 * @param $table
 * @return {null}
 */
export function getLastRow({ $grid, $table }) {
  const tableInstance = $grid || $table;
  const fullData = tableInstance.getTableData().fullData;
  if (fullData.length < 1) {
    return null;
  }
  return fullData[fullData.length - 1];
}

/**
 * 监听鼠标选择区域
 * @param rows
 * @param cols
 * @param $grid
 * @param $table
 */
export function handleCellAreaSelectionEnd({ rows, cols, $grid, $table, $event }) {
  const tableInstance = $grid || $table;
  const checkboxRecords = tableInstance.getCheckboxRecords();
  // 如果当前页面有选中记录,且通过左键来点击或者选取多个单元格
  if (Array.isArray(checkboxRecords) && checkboxRecords.length > 0 && $event.button === 0) {
    // 判断选择的开始行的选中状态
    // 如果是选中，就取消选择，后面选择的行也是取消选中
    // 如果不是选中，就选中，后面选择的行也是选中
    const activeCellArea = tableInstance.getActiveCellArea();
    // 如果最开始选中的不是checkbox列才出发批量选中或取消选中的功能
    if (activeCellArea.column.type !== 'checkbox') {
      tableInstance.setCheckboxRow(rows, !(checkboxRecords.indexOf(activeCellArea.row) > -1));
    }
  }
  if (!this.realDynamicStatisticsConfig.enabled) {
    return;
  }
  if (cols.length !== 1) {
    this.dynamicStatistics = 0;
    return;
  }
  const column = cols[0];
  this.dynamicStatistics = countSingleColumn({
    column,
    rows,
    dynamicStatistics: true,
    validate: ({ column }) => {
      // 如果不是配置化的列就直接返回true，即不校验
      /*const params = column.params;
      if (!params) {
        return true;
      }
      const metaDataField = params.metaDataField;
      if (!metaDataField) {
        return true;
      }
      // 配置化页面日期时间的值有可能是时间戳，这里要校验
      const fieldDataType = metaDataField.fieldDataType;
      for (const item of FIELD_DATA_TYPE_ALL_DATE_TIME_OPTIONS) {
        if (fieldDataType === item.value) {
          return false;
        }
      }
      const fieldInputType = metaDataField.fieldInputType;
      for (const item of FIELD_INPUT_TYPE_ALL_DATE_TIME_OPTIONS) {
        if (fieldInputType === item.value) {
          return false;
        }
      }*/
      return true;
    }
  });
}

/**
 * copyMethod是需要先进行区域选择才能触发，如果没有选择区域，只是选择部分文字，但是也要复制功能，就要实现menu-click方法
 * @param menu
 * @param row
 * @param column
 */
export function handleMenuClick({ $table, menu }) {
  if (menu.code === COPY_CODE) {
    if (this.$selectedText) {
      XEClipboard.copy(this.$selectedText);
      // 参考node_modules/vxe-table-plugin-menus/index.ts handleCopyOrCut方法和checkPrivilege方法
      // 如果$vxe.clipboard是空，右键菜单的粘贴按钮就会被禁用
      // switch (code) {
      // case 'PASTE_CELL':
      //   const { $vxe } = $table
      //   const { clipboard } = $vxe
      //   item.disabled = !clipboard || !clipboard.text
      //   break
      // }
      const $vxe = $table.$vxe;
      if ($vxe.clipboard) {
        $vxe.clipboard.text = this.$selectedText;
      } else {
        $vxe.clipboard = { text: this.$selectedText };
      }
      this.$selectedText = '';
    }
  }
}

/**
 * 复制粘贴自动增行
 * @param insertRows: Object
 * @param row: Function
 * @param $table: vxeTableInstance
 * @param tableData: Array
 * @param beforeCreateRow: Function
 */
export function handleCreateRows({ insertRows, row, $table, tableData, beforeCreateRow }) {
  insertRows.forEach(async item => {
    const newRow = row();
    const pasteMethod = [];
    const post = () => {
      Object.keys(item).forEach(property => {
        const column = $table.getColumnByField(property);
        pasteMethod.push(
          $table.clipConfig.pasteMethod({
            row: newRow,
            column,
            cellValue: item[property],
            insertRows
          })
        );
      });

      Promise.all(pasteMethod).then(result => {
        const isAllResultFalse = result.every(item => item === false);
        // 全部列为false，则不能添加新行
        if (!isAllResultFalse) {
          tableData.push(newRow);
          $table.reloadRow(newRow);
        }
      });
    };
    if (!beforeCreateRow) {
      return post();
    }

    const before = beforeCreateRow(newRow);
    if (before && before.then) {
      before.then(post(), () => {
        // this.$emit('cancel', newRow);
      });
    } else if (before !== false) {
      post();
    }
  });
}

export async function coreGetNewRows(args) {
  // 如果调用者没有自定义getNewRows方法，就通过pasteMethod和createData来自动创建行，其中pasteMethod已经对单元格是否可编辑做了校验
  const { $grid, $table, insertRows } = args;
  const tableInstance = $grid || $table;
  const newRows = [];
  const promiseArray = [];
  const columns = tableInstance.getTableColumn().fullColumn;
  for (const item of insertRows) {
    const rowPromiseArray = [];
    const row = await this.getNewRow({ $grid, $table });
    for (const property in item) {
      // 找出对应的column
      for (const column of columns) {
        if (column.field !== property) {
          continue;
        }
        if (this.realClipConfig.pasteMethod) {
          // 在某些场景，粘贴是需要异步查询数据的
          const result = this.realClipConfig.pasteMethod({
            row,
            column,
            cellValue: item[property],
            $table,
            $grid
          });
          if (result instanceof Promise) {
            rowPromiseArray.push(result);
          }
        }
        break;
      }
    }
    if (rowPromiseArray.length > 0) {
      // 异步粘贴的情况下至少有一个异步是fullfilled
      promiseArray.push(
        Promise.allSettled(rowPromiseArray).then(results => {
          for (const result of results) {
            if (result.status === 'fulfilled') {
              return;
            }
          }
          // 所有异步请求都失败就将row从数组中清除
          newRows.splice(newRows.indexOf(row), 1);
        })
      );
      // 先放进数组占位，保证顺序
      newRows.push(row);
    } else {
      // 同步粘贴的情况下，这里需要判断是否粘贴成功，如果没有粘贴成功的，就不放入newRows中
      let flag = false;
      for (const property in item) {
        const value = row[property];
        if (!appUtils.isEmpty(value)) {
          flag = true;
          break;
        }
      }
      if (flag) {
        newRows.push(row);
      }
    }
  }
  await Promise.all(promiseArray);
  return newRows;
}

/**
 * 新增多行，主要用于复制粘贴自动增行
 * @param args
 * @return {Promise}
 */
export function coreAddNewRows(args) {
  if (this.handleAddNewRows) {
    this.handleAddNewRows(args);
  } else {
    const result = appendRow(args);
    return result.then(() => {
      this.handleAddNewRowsFinish && this.handleAddNewRowsFinish(args);
    });
  }
}

/**
 * 新增一行，主要用户向下新增一行
 * @param $grid
 * @param $table
 */
export function coreAddNewRow({ $grid, $table }) {
  const lastRow = this.getLastRow({ $grid, $table });
  // 校验最后一行是否和新增行的内容是一样的,如果一样，表名最后一行没有被修改过
  if (!this.getNewRow) {
    return;
  }
  const newRow = this.getNewRow({ $grid, $table });
  if (!newRow) {
    return;
  }
  // 异步函数需要在then中处理
  if (newRow instanceof Promise) {
    this.keyDownCaptureAddNewRowFlag = true;
    newRow
      .then(newRow => {
        this.coreHandleAddNewRow && this.coreHandleAddNewRow({ lastRow, newRow, $grid, $table });
      })
      .finally(() => {
        this.keyDownCaptureAddNewRowFlag = false;
      });
    return;
  }
  this.coreHandleAddNewRow && this.coreHandleAddNewRow({ lastRow, newRow, $grid, $table });
}

export async function coreHandleAddNewRow({ lastRow, newRow, $grid, $table }) {
  if (!this.compareRow({ row1: lastRow, row2: newRow })) {
    if (this.handleAddNewRow) {
      await this.handleAddNewRow({ row: newRow, $grid, $table });
    } else {
      const tableInstance = $grid || $table;
      if (Array.isArray(tableInstance.$options.propsData.data)) {
        tableInstance.$options.propsData.data.push(newRow);
        await this.$nextTick();
      } else {
        await tableInstance.insertAt(newRow, -1);
      }
      setTimeout(() => {
        activeFirstCell({ $grid, $table, row: newRow });
      });
    }
  }
}

// -------------------------------------computed部分的函数------------------------------
/**
 * 动态统计配置
 * @return {{enabled: boolean}|({enabled: boolean} & {enabled?: boolean})}
 */
export function realDynamicStatisticsConfig() {
  const defaultConfig = {
    enabled: false
  };
  if (!this.dynamicStatisticsConfig) {
    return defaultConfig;
  }
  return Object.assign(defaultConfig, this.dynamicStatisticsConfig);
}

/**
 * 复制粘贴配置
 * @return {any|{isCut: boolean, copyMethod: copyMethod, createRowsMethod: (function(*=): *[]), isPaste: boolean, pasteMethod: pasteMethod, isCopy: boolean, isRowIncrement: boolean}}
 */
export function realClipConfig() {
  const defaultClipConfig = {
    isCopy: true,
    isCut: false,
    isPaste: true,
    isRowIncrement: true,
    copyMethod: ({ row, column, cellValue }) => {
      if (!column.formatter) {
        return cellValue;
      }
      return column.formatter({ row, column, cellValue });
    },
    pasteMethod: ({ row, column, cellValue, $table, $grid }) => {
      const tableInstance = $grid || $table;
      if (!isEditable({ $grid, $table, row, column })) {
        return;
      }
      // pasteMethod不单是用于粘贴已有单元格，也会用于粘贴新增单元格，因此要判断一下是否需要updateData来提高性能
      const flag = tableInstance.getTableData().fullData.indexOf(row) > -1;
      const params = column.params;
      if (params || this.handlePasteMethod) {
        let $pasteMethod = this.handlePasteMethod;
        if (params && params.pasteMethod) {
          $pasteMethod = params.pasteMethod;
        }
        if ($pasteMethod) {
          const result = $pasteMethod({ row, column, cellValue, $table, $grid });
          if (result instanceof Promise) {
            // 这里需要将异步结果返回出去
            return result.then(() => {
              if (flag) {
                tableInstance.updateData();
              }
            });
          }
          if (flag) {
            tableInstance.updateData();
          }
          return;
        }
      }
      row[column.field] = cellValue;
      if (flag) {
        tableInstance.updateData();
      }
    },
    /**
     * 多行复制插入，调用者需要实现getNewRows方法和handleAddNewRows方法
     * getNewRows方法可以返回一个数组或者promise，如果返回promise,就需要实现handleAddNewRows方法，如果是返回数组，则不需要实现handleAddNewRows方法
     * @param args
     * @return {array}
     */
    createRowsMethod: args => {
      // 创建newRows有可能涉及异步调用接口的操作，为了性能考虑，这里使用没有使用getNewRow方法，使调用者可以根据自己情况优化
      const { $grid, $table } = args;
      let newRows = null;
      if (this.getNewRows) {
        newRows = this.getNewRows(args);
      } else {
        newRows = this.coreGetNewRows(args);
      }
      // getNewRows方法有可能返回的是一个promise
      if (newRows instanceof Promise) {
        newRows.then(rows => {
          this.coreAddNewRows({ rows, $table, $grid });
        });
      } else {
        this.coreAddNewRows({ newRows, $table, $grid });
      }
      // 统一返回空数组
      return [];
    }
  };
  if (!this.clipConfig) {
    return defaultClipConfig;
  }
  return Object.assign(defaultClipConfig, this.clipConfig);
}

/**
 * 表格底部的配置，如修改人，修改时间的显示
 * @return {{show: boolean, list: [{values: [dynamicStatisticsPageFooterConfig.dynamicStatistics], label: string}]}}
 */
export function dynamicStatisticsPageFooterConfig() {
  return {
    show: true,
    list: [{ label: '动态统计', values: [this.dynamicStatistics] }]
  };
}

/**
 * 菜单配置
 * @return {{}}
 */
export function realMenuConfig() {
  const defaultConfig = {
    body: {
      options: [
        [
          { code: COPY_CODE, name: '复制 (Ctrl+C)', prefixIcon: 'el-icon-document-copy' },
          { code: PASTE_CODE, name: '粘贴 (Ctrl+V)', prefixIcon: 'fa fa-paste' }
        ]
      ]
    },
    header: {
      options: [
        [
          { code: TABLE_SETTING_STYLE, name: '表格样式', prefixIcon: 'el-icon-setting' },
          { code: FIXED_LEFT_COLUMN, name: '将列固定到左侧', prefixIcon: 'fa fa-paste' },
          { code: FIXED_RIGHT_COLUMN, name: '将列固定到右侧', prefixIcon: 'fa fa-paste' },
          { code: CLEAR_FIXED_COLUMN, name: '清除固定列', prefixIcon: 'fa fa-paste' }
        ]
      ]
    }
  };
  if (!this.menuConfig) {
    return defaultConfig;
  }
  Object.assign(defaultConfig, this.menuConfig);
  return defaultConfig;
}

export default {
  data() {
    return {
      // 动态统计，用于鼠标选择部分单元格是自动统计
      dynamicStatistics: 0
    };
  },
  methods: {
    handleMouseDownCapture,
    handleActiveCellChangeStart,
    handleActiveCellChangeEnd,
    handleCellAreaSelectionEnd,
    handleMenuClick,
    handleCellDblclick,
    /**
     * @desc 点击右键的回调函数，将用户选中的内容保存在组件里面，
     * 满足廖仲华希望能选中单元格也可以只选中单元格内部文字的要求
     * @param event
     */
    handleMouseDown(event) {
      if (event.button === 2) {
        this.$selectedText = window.getSelection().toString();
      }
    },
    handleKeydown,
    handleKeyDown,
    /**
     * @desc 校验row1和row2的内容是否一样
     * @param row1
     * @param row2
     * @return {boolean} 相同返回true, 不同返回false
     */
    compareRow({ row1, row2 }) {
      // 如果row1和row2其中一个是空的，也要返回false
      if (!row1 || !row2) {
        return false;
      }
      // vxe-grid会对行增加_XID属性，需要去掉
      let arr = this.getIgnoreCompareRowProperty();
      arr = arr.concat('_X_ID');
      row1 = JSON.parse(JSON.stringify(row1));
      for (const key in row1) {
        if (arr.indexOf(key) > -1) {
          delete row1[key];
        }
      }
      row2 = JSON.parse(JSON.stringify(row2));
      for (const key in row2) {
        if (arr.indexOf(key) > -1) {
          delete row2[key];
        }
      }
      // 使用json.stringify来比较，有可能会因为输入框会将null变成''而导致结果是false
      return JSON.stringify(row1) === JSON.stringify(row2);
    },
    /**
     * 获取最新一行
     * @param $grid
     * @param $table
     * @return {null}
     */
    // getNewRow({$grid, $table}) {
    //   return createRow({$grid, $table});
    // },
    getLastRow,
    /**
     * 获取行比较时忽略的属性
     * @return {array}
     */
    getIgnoreCompareRowProperty() {
      return [];
    },
    /**
     * 向下增行是否可用
     * @return {boolean}
     */
    isAddNewRowEnabled() {
      return true;
    },
    handleKeyDownCapture,
    coreHandleAddNewRow,
    handleCreateRows,
    coreGetNewRows,
    coreAddNewRows,
    coreAddNewRow
  },
  computed: {
    realDynamicStatisticsConfig,
    realClipConfig,
    dynamicStatisticsPageFooterConfig,
    realMenuConfig
  }
};
